import { getData, postData, putData, deleteData } from '@/utils/api';
import { ApiResponse, RequestOptions } from '@/types/api';
import {
  FootballlogApiModel,
  FootballlogListApiModel,
  FootballlogListApiPagingModel,
  FootballlogGbnlogsApiModel,
  FootballlogCalendarMappingApiModel
} from '@/types/footballlogs';
import { FootballlogCreateDataModel, FootballlogUpdateDataModel } from '@/types/footballlogs';

/**
 * 最新のサッカーノート取得
 */
export async function getFootballlog(
  id: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogApiModel | null>> {
  const apiPath = `footballlogs/${id}/gbnlogs/`;

  return await getData<FootballlogApiModel | null>(apiPath, options);
}

/**
 * 最新のサッカーノート取得
 */
export async function getCurrentFootballlog(options?: RequestOptions): Promise<ApiResponse<FootballlogApiModel>> {
  const apiPath = `footballlogs/gbnlogs/current/`;

  return await getData<FootballlogApiModel>(apiPath, options);
}

/**
 * サッカーノート一覧を月単位で取得
 */
export async function getFootballlogsByYearMonth(
  yyyymm: string,
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogListApiModel>> {
  const apiPath = `footballlogs/month/${yyyymm}/?limit=${limit}&offset=${offset}`;

  return await getData<FootballlogListApiModel>(apiPath, options);
}

/**
 * サッカーノート一覧のカレンダーマッピング
 */
export async function getFootballlogsCalendarMapping(
  yyyymm: string,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogCalendarMappingApiModel>> {
  const apiPath = `footballlogs/calendar-mapping/${yyyymm}/`;

  return await getData<FootballlogCalendarMappingApiModel>(apiPath, options);
}

/**
 * サッカーノート一覧を取得(ページング形式)
 */
export async function getFootballlogsPaging(
  pageNumber?: number,
  keyword?: string,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogListApiPagingModel>> {
  // クエリパラメータ設定
  const queryParams = new URLSearchParams();
  // ページ番号
  if (pageNumber) {
    queryParams.append('page', String(pageNumber));
  }
  // 検索キーワード
  if (keyword) {
    queryParams.append('q', keyword);
  }

  const apiPath = `footballlogs/paging/?${queryParams.toString()}`;

  return await getData<FootballlogListApiPagingModel>(apiPath, options);
}

/**
 * サッカーノート(GBN)一覧を取得
 * HOMEのGood・Bad・Next一覧
 */
export async function getFootballlogGbnlogs(
  limit: number,
  offset: number,
  options?: RequestOptions
): Promise<ApiResponse<FootballlogGbnlogsApiModel>> {
  const apiPath = `footballlogs/gbnlogs/?limit=${limit}&offset=${offset}`;

  return await getData<FootballlogGbnlogsApiModel>(apiPath, options);
}

/**
 * 新しいのサッカーノート（Gbnlog）の作成
 */
export async function createGbnlog(
  formData: FootballlogCreateDataModel,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `footballlogs/`;

  return await postData<void>(apiPath, csrftoken, formData, options);
}

/**
 * サッカーノート（Gbnlog）の更新
 */
export async function updateGbnlog(
  id: number,
  formData: FootballlogUpdateDataModel,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `footballlogs/${String(id)}/`;

  return await putData<void>(apiPath, csrftoken, formData, options);
}

/**
 * サッカーノート（Gbnlog）の削除
 */
export async function deleteGbnlog(
  id: number,
  csrftoken: string,
  options?: RequestOptions
): Promise<ApiResponse<void>> {
  const apiPath = `footballlogs/${String(id)}/`;

  return await deleteData<void>(apiPath, csrftoken, options);
}
